<template>
  <section id="related-products" class="landscape-products-wrap" v-if="hasAnyProduct">
    <div class="products-header">
      <h5 class="section-title">{{ $trans("storefront::product.related_products") }}</h5>
    </div>

    <div class="landscape-products" ref="productsPlaceholder">
      <product-card
        v-for="(product, index) in products" :key="index"
        :product="product"
        :isAdmin="isAdmin"
        class="margin-10"
        :daily-purchase-limit-amount="dailyPurchaseLimitAmount"
        :hot-products-disclaimer="hotProductsDisclaimer"
        :target-from-id="'relatedProductCard'"
        :payment_methods="payment_methods"
      />
    </div>
  </section>
</template>

<script>
import { relatedProducts as config } from "../../../config/products"
import ProductCard from "./../../ProductCard.vue"

export default {
  name: "RelatedProducts",
  components: { ProductCard },
  props: ["products", "isAdmin", "dailyPurchaseLimitAmount", "hotProductsDisclaimer", "payment_methods"],
  computed: {
    hasAnyProduct() {
      return this.products.length !== 0
    }
  },
  mounted() {
    $(this.$refs.productsPlaceholder).slick(config.slickOptions)
  }
}
</script>

<style lang="scss">
#related-products {
  .margin-10 {
    margin: 0 10px;
  }

  .arrow-prev {
    left: -60px;
    font-size: 50px;
  }

  .arrow-next {
    right: -60px;
    font-size: 50px;
  }
}
</style>
